import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import ReactTooltip from 'react-tooltip';
import HorizontalScroll from 'react-scroll-horizontal';
import { useMappedState } from 'redux-react-hook';

import { trans } from '../../../localization';
import { EnumChatAppType } from '../../../constants/enum';

const ChatSendButton = ({ disable = false, onClick, id }) => (
  <div className="icon-send">
    <i
      className={`fas fa-paper-plane icon-send-msg ${disable ? 'disable' : ''}`}
      onClick={() => !disable && onClick()}
      data-tip
      data-for={`send-message-${id}`}
    />
    <ReactTooltip id={`send-message-${id}`} effect="solid" place="top">
      {!disable
        ? trans('nex_press_enter_to_send')
        : trans('nex_type_anything_to_send')}
    </ReactTooltip>
  </div>
);

const ChatSuggestion = ({ message, onClick }) => (
  <div title={message} className="chat-suggestion" onClick={onClick}>
    {message}
  </div>
);

const InputText = ({
  draftMessage,
  handleChangeDraftMessage,
  handleSendMessage,
  scrollToBottom,
  handleClearUnreadMessage,
  handleFocusChatText,
  handleBlurChatText,
}) => {
  const [currentMessage, setCurrentMessage] = useState(draftMessage);
  useEffect(
    () => {
      setCurrentMessage(draftMessage);
    },
    [draftMessage],
  );
  const storeCurrentMsgToDraftMsg = useRef();
  const handleChangeCurrentMessage = (e) => {
    const msg = e.target.value;
    setCurrentMessage(msg);
    clearTimeout(storeCurrentMsgToDraftMsg.current);
    storeCurrentMsgToDraftMsg.current = setTimeout(() => {
      handleChangeDraftMessage(msg);
    }, 200);
  };

  const handleOnKeyPress = async (event) => {
    if (event.key === 'Enter') {
      clearTimeout(storeCurrentMsgToDraftMsg.current);
      setCurrentMessage('');
      await handleSendMessage(currentMessage.trim());
      scrollToBottom();
    }
  };
  return (
    <input
      type="text"
      className="input-message"
      placeholder={trans('nex_type_your_message')}
      value={currentMessage}
      onChange={handleChangeCurrentMessage}
      onKeyPress={handleOnKeyPress}
      onMouseDown={handleClearUnreadMessage}
      onFocus={handleFocusChatText}
      onBlur={handleBlurChatText}
    />
  );
};

const ChatTextFunction = memo(
  ({ appType, handleClearUnreadMessage, handleSendMessage }) => {
    const mapState = useCallback(state => ({
      chatSuggestionNowShip:
        state.ship.general.metadata.reason_notes.chat_suggestion.customer_ship,
    }), []);
    const { chatSuggestionNowShip } = useMappedState(mapState);
    const getSuggestionList = useCallback(
      () => {
        try {
          switch (appType) {
            case EnumChatAppType.NOW_SHIP.id: {
              return chatSuggestionNowShip.map(item => item.note_content);
            }
            default:
              return CONFIG.MESSAGE_SUGGESTION_LIST;
          }
        } catch (ex) {
          return CONFIG.MESSAGE_SUGGESTION_LIST;
        }
      },
      [appType, chatSuggestionNowShip],
    );
    const messageSuggestionList = useMemo(getSuggestionList, [
      getSuggestionList,
    ]);
    return (
      <div className="input-chat-text-function">
        <div className="input-chat-text-suggestion">
          <HorizontalScroll reverseScroll>
            {messageSuggestionList.map(suggestMessage => (
              <ChatSuggestion
                key={suggestMessage}
                message={trans(suggestMessage)}
                onClick={() => {
                  handleClearUnreadMessage();
                  handleSendMessage(suggestMessage);
                }}
              />
            ))}
          </HorizontalScroll>
        </div>
      </div>
    );
  },
);

const InputChatText = ({
  id,
  appType,
  isDisabled,
  scrollToBottom,
  draftMessage,
  handleSendMessage,
  handleChangeDraftMessage,
  handleClearUnreadMessage,
  handleFocusChatText,
  handleBlurChatText,
}) => (
  <div className="input-chat-text">
    {isDisabled ? (
      <div className="disabled-input">{trans('nex_chat_disable')}</div>
    ) : (
      <React.Fragment>
        <ChatTextFunction
          appType={appType}
          handleClearUnreadMessage={handleClearUnreadMessage}
          handleSendMessage={handleSendMessage}
        />
        <div className="input-chat-text-input">
          <InputText
            draftMessage={draftMessage}
            handleChangeDraftMessage={handleChangeDraftMessage}
            handleSendMessage={handleSendMessage}
            scrollToBottom={scrollToBottom}
            handleClearUnreadMessage={handleClearUnreadMessage}
            handleFocusChatText={handleFocusChatText}
            handleBlurChatText={handleBlurChatText}
          />
          <div className="icon-send-wrapper">
            <ChatSendButton
              id={id}
              disable={draftMessage.length === 0}
              onClick={handleSendMessage}
            />
          </div>
        </div>
      </React.Fragment>
    )}
  </div>
);

export default InputChatText;



// WEBPACK FOOTER //
// ./foody/src/pages/ChatBox/ChatChannel/InputChatText.jsx